import { render, staticRenderFns } from "./timelinePoints.vue?vue&type=template&id=6c6160d2&scoped=true"
import script from "./timelinePoints.vue?vue&type=script&lang=js"
export * from "./timelinePoints.vue?vue&type=script&lang=js"
import style0 from "./timelinePoints.vue?vue&type=style&index=0&id=6c6160d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6160d2",
  null
  
)

export default component.exports